import * as React from 'react';
import {Button, Cluster, Cover, Dialog, Heading, Icon, Notification, Stack, Table, Template} from '@pluto-tv/assemble';
import {ITimeline} from 'features/channelTimelines/channelTimelinesApi';
import {formatDateWithLocalTimezone} from 'utils/dateUtils';

interface Props {
  isOpen: boolean;
  saveAndProceed: () => void;
  timelines: ITimeline[];
}

const renderTimelinesTable = (timelines: ITimeline[]) => {
  if (!timelines.length) return null;

  return (
    <Table
      wrapContent={true}
      fixedHeader={true}
      cols={[
        {
          label: 'Episode',
          transform: row => row.episode?.name || 'Unknown Episode',
        },
        {
          label: 'Start at',
          transform: row => {
            const start = new Date(row.start);
            return formatDateWithLocalTimezone(new Date(start), 'h:mm a');
          },
        },
      ]}
      rows={timelines}
    ></Table>
  );
};

const ExcludedEpisodeModal = React.memo(({isOpen = false, saveAndProceed, timelines}: Props) => {
  const handleOnClose = () => {
    saveAndProceed();
  };

  return (
    <Dialog isOpen={isOpen} onClose={handleOnClose} width='54rem' height='48rem'>
      <Template label='header'>
        <Heading level='h2'>
          <Icon icon='warning' color='warning' space='xxsmall'>
            Attention
          </Icon>
        </Heading>
      </Template>
      <Template label='body'>
        <Cover gutter='medium' coverTemplateHeight='100%' overflow='auto' scrolling={true}>
          <Template label='header'>
            <Stack space='medium'>
              <Notification type='warning'>
                The following episode(s) are being published close to their scheduled start time and will be discarded.
              </Notification>
            </Stack>
          </Template>

          <Template label='cover'>{renderTimelinesTable(timelines)}</Template>
        </Cover>
      </Template>
      <Template label='footer'>
        <Cluster justify='space-between' align='end'>
          <div></div>
          <Cluster space='small'>
            <Button size='small' type='primary' onClick={handleOnClose}>
              Continue
            </Button>
          </Cluster>
        </Cluster>
      </Template>
    </Dialog>
  );
});

export default ExcludedEpisodeModal;
